import { render, staticRenderFns } from "./pianificazioneAttivita.vue?vue&type=template&id=6b0445fe"
import script from "./pianificazioneAttivita.vue?vue&type=script&lang=js"
export * from "./pianificazioneAttivita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports